export const checkoutUrl = "https://pay.hotmart.com/D90668565A";

export const logicImages = {
  hero: "https://www.apple.com/v/logic-pro/n/images/overview/welcome/hero_endframe__dc7irycb3gia_large.jpg",
  creatorStudio: "https://www.apple.com/v/logic-pro/n/images/overview/welcome/welcome_banner__ehgiu77lsru6_large.png",
  plugins: "https://www.apple.com/v/logic-pro/n/images/overview/sounds/banner_plug_in__eee8644wmzki_large.jpg",
  mixing: "https://www.apple.com/v/logic-pro/n/images/overview/mixing/mixing_hero_endframe__do9497nn8w8y_xlarge.jpg",
  ipad: "https://www.apple.com/v/logic-pro/n/images/overview/ipad/gallery_compatibility__ekbo7xua3q2q_large.jpg",
  ai: "https://www.apple.com/v/logic-pro/n/images/overview/ai/gallery_chord__bm9onnzkojrm_large.jpg",
  flexPitch: "https://www.apple.com/v/logic-pro/n/images/overview/workflows/audio_editing__sjlh2wo4tn6a_large.jpg",
  editingTimeline: "https://www.apple.com/v/logic-pro/n/images/overview/workflows/performance__d3sfgt3z6diu_large.jpg",
  sessionPlayers: "https://www.apple.com/v/logic-pro/n/images/overview/ai/gallery_keyboard__b9gctw0dozrm_large.jpg",
  recording: "https://www.apple.com/v/logic-pro/n/images/overview/apple_integration/gallery_memos__bh1tqs0unaoi_large.jpg",
  effects: "https://www.apple.com/v/logic-pro/n/images/overview/sounds/plug_ins__fjyg9slhzxyu_large.jpg",
};

export const producer = {
  name: "Mariano Júnior",
  role: "Produtor musical e audiovisual • fundador do Estúdio Hertz",
  image: "https://customer-assets.emergentagent.com/job_logic-pro-pressa/artifacts/8h0zckmt_IMG_7490.jpg",
  bio: "Mariano Júnior é produtor musical e audiovisual com mais de 20 anos de experiência. Já formou mais de 6.000 alunos e construiu uma abordagem direta, prática e baseada no mundo real de estúdio.",
};

export const trustPills = [
  "Do zero à produção real",
  "Inclui recursos de IA no Logic",
  "Método direto, moderno e sem enrolação",
];

export const metrics = [
  { value: "+6.000", label: "alunos impactados" },
  { value: "20+ anos", label: "de experiência prática" },
  { value: "15 módulos", label: "na ordem certa para aprender" },
  { value: "1 objetivo", label: "fazer você produzir logo" },
];

export const promisePillars = [
  {
    title: "Sem curva de aprendizado confusa",
    text: "Você elimina a sensação de estar perdido e entra direto no que realmente importa dentro do Logic Pro.",
  },
  {
    title: "Aprendizado na ordem certa",
    text: "Cada aula te leva para a próxima etapa com lógica, aplicação prática e ganho real de velocidade.",
  },
  {
    title: "Produção desde as primeiras aulas",
    text: "Nada de semanas só entendendo menus. Aqui você aprende configurando, gravando, editando e criando.",
  },
];

export const courseBullets = [
  "Configurar o Logic Pro corretamente desde o início",
  "Navegar pela interface sem se perder",
  "Gravar, editar e organizar sessões com velocidade",
  "Usar recursos de inteligência artificial dentro do Logic",
  "Mixar e finalizar músicas com mais clareza e confiança",
  "Criar um fluxo de trabalho profissional, direto e repetível",
];

export const showcaseCards = [
  {
    title: "Mixer",
    text: "Entenda canais, envio, automação e tomada de decisão com clareza visual.",
    image: logicImages.mixing,
  },
  {
    title: "Edição",
    text: "Refine timing e afinação com um fluxo simples e objetivo.",
    image: logicImages.editingTimeline,
  },
  {
    title: "Plugins",
    text: "Use os recursos certos sem se afogar em opções desnecessárias.",
    image: logicImages.plugins,
  },
  {
    title: "Gravação",
    text: "Organize takes e sessões para produzir com segurança desde cedo.",
    image: logicImages.recording,
  },
  {
    title: "FlexPitch",
    text: "Corrija, refine e aprimore vozes com mais precisão.",
    image: logicImages.flexPitch,
  },
  {
    title: "Session Players",
    text: "Acelere ideias com IA aplicada à música de forma prática.",
    image: logicImages.sessionPlayers,
  },
];

export const accessCards = [
  {
    label: "Plano mensal",
    value: "R$ 39,90/mês",
    detail: "Acesso ao Logic Pro e outros softwares profissionais.",
  },
  {
    label: "Plano estudante",
    value: "R$ 14,90/mês",
    detail: "Opção acessível para quem está estudando e quer começar logo.",
  },
  {
    label: "Teste",
    value: "1 mês grátis",
    detail: "Você pode testar antes e iniciar com investimento mínimo.",
  },
];

export const ipadBenefits = [
  "Produzir em qualquer lugar",
  "Mais liberdade criativa sem depender de setup completo",
  "Interface moderna e intuitiva para toque",
  "Base do curso que serve para entender o Logic em qualquer plataforma",
];

export const modules = [
  {
    title: "Setup inicial",
    summary: "Configuração correta desde o início.",
    result: "Você começa no lugar certo e evita erros que travam a evolução.",
  },
  {
    title: "Interface",
    summary: "Entenda o Logic sem se perder.",
    result: "Você localiza tudo com agilidade e navega com confiança.",
  },
  {
    title: "Shortcuts",
    summary: "Produza com velocidade.",
    result: "Atalhos certos para ganhar tempo em qualquer sessão.",
  },
  {
    title: "Templates",
    summary: "Nunca comece do zero.",
    result: "Downloads de templates usados em mix profissionais de vários estilos para você nunca começar sua música do zero.",
  },
  {
    title: "Gravação",
    summary: "Áudio e MIDI na prática.",
    result: "Capte ideias com método e menos retrabalho.",
  },
  {
    title: "Presets",
    summary: "Agilidade com sons.",
    result: "Escolha e ajuste timbres com mais rapidez.",
  },
  {
    title: "Edição",
    summary: "Refinamento técnico.",
    result: "Corrija timing, cortes e estrutura com precisão.",
  },
  {
    title: "Afinação",
    summary: "Flex Pitch na prática.",
    result: "Vocais mais afinados e naturais sem complicação.",
  },
  {
    title: "Instrumentos",
    summary: "Criação dentro do Logic.",
    result: "Explore recursos musicais sem depender de dezenas de plugins.",
  },
  {
    title: "Loops",
    summary: "Produção rápida.",
    result: "Monte ideias, arranjos e referências com velocidade.",
  },
  {
    title: "Session Players",
    summary: "IA aplicada à música.",
    result: "Use músicos virtuais para acelerar composição e arranjos.",
  },
  {
    title: "Stem Splitter",
    summary: "Separação de faixas.",
    result: "Separe instrumentos de qualquer música usando a IA do Logic. Faça playback, remixes e muito mais em segundos.",
  },
  {
    title: "GPT",
    summary: "Organização inteligente.",
    result: "Estruture ideias, processos e referências com apoio de IA.",
  },
  {
    title: "Mixagem",
    summary: "Clareza e equilíbrio.",
    result: "Tome decisões com mais segurança e faça sua música respirar.",
  },
  {
    title: "Masterização",
    summary: "Finalização profissional.",
    result: "Aprenda a deixar sua música com volume competitivo no Streaming mantendo a qualidade e nitidez da sua mix.",
  },
];

export const objections = [
  {
    title: "Sou iniciante",
    answer: "Perfeito. O curso foi desenhado para quem quer sair do zero sem se perder em excesso de teoria ou menus intermináveis.",
  },
  {
    title: "Não tenho equipamento",
    answer: "Você pode começar com computador ou até iPad. E hoje já existe um caminho acessível para ter acesso ao Logic Pro com baixo investimento inicial.",
  },
  {
    title: "Não tenho tempo",
    answer: "O método é direto ao ponto. Você aprende o que gera resultado primeiro, sem enrolação e sem etapas desnecessárias.",
  },
  {
    title: "Já tentei e não consegui",
    answer: "A diferença aqui é a sequência certa. Você entende o software dentro de um método estruturado, com aplicação real e progressão lógica.",
  },
  {
    title: "Não tenho o Logic ainda",
    answer: "No curso damos um caminho gratuito para você começar na área de downloads ;)",
  },
];

export const bonuses = [
  {
    title: "Templates de vários estilos",
    highlight: "GRÁTIS!",
    subtitle: "Nunca comece do zero.",
  },
  {
    title: "Downloads de loops exclusivos",
    subtitle: "de Piseiro, pagode, samba, sertanejo e muito mais",
  },
  {
    title: "Método organizado",
    subtitle: "para você já sair produzindo nas primeiras aulas.",
  },
];

export const testimonials = [
  {
    author: "@leoacevedobr",
    quote: "Muito aprendizado nessa live de Mixagem com o Mariano do Estúdio Hertz.",
    image: "https://customer-assets.emergentagent.com/job_logic-pro-pressa/artifacts/tqv5mgpt_IMG_9902-624x1024.webp",
  },
  {
    author: "@fabiosantacruz",
    quote: "Conteúdo bom demais. Feliz por ter adquirido.",
    image: "https://customer-assets.emergentagent.com/job_logic-pro-pressa/artifacts/8elhueb6_IMG_9903-744x1024.webp",
  },
  {
    author: "@hey_joe_w",
    quote: "Aprendendo com Mariano Júnior e Estúdio Hertz.",
    image: "https://customer-assets.emergentagent.com/job_logic-pro-pressa/artifacts/e16q931q_IMG_9905-600x1024.webp",
  },
  {
    author: "@diegonovaisguitar",
    quote: "Curso top de mixagem e produção musical.",
    image: "https://customer-assets.emergentagent.com/job_logic-pro-pressa/artifacts/o4hfuxvh_IMG_9907-603x1024.webp",
  },
];